//add support for open comments immediatly looking at url

//when show comments button is clicked we need to
// 1. show modal
// 2. add close listener
// 3. fetch disqus comments window.loadDisqus

const commentButton = document.querySelector(".comments-btn a");

commentButton && commentButton.addEventListener("click", getDisqusCommentsOnce);
function getDisqusCommentsOnce(e) {
  loadDisqus();
  commentButton.removeEventListener("click", getDisqusCommentsOnce); //remove this function so it wont fire again
}
